import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { platformChatService } from '../../../services/PlatformChatService';
import { chatQueryKeys } from '../chatQueryKeys';

export function usePlatformChatMessageAttachmentDataQuery(
  sessionId: string,
  messageId: string,
  attachmentId: string,
  options?: { enabled?: boolean },
) {
  const { user } = useAuth();
  const isEnabled =
    (options?.enabled ?? true) &&
    Boolean(user) &&
    sessionId.length > 0 &&
    messageId.length > 0 &&
    attachmentId.length > 0;

  return useQuery({
    queryKey: chatQueryKeys.messageAttachmentData(
      sessionId,
      messageId,
      attachmentId,
    ),
    enabled: isEnabled,
    // Keep while the message is on screen; allow GC after leaving the chat.
    staleTime: Infinity,
    gcTime: 1000 * 60 * 10,
    queryFn: () =>
      platformChatService.downloadMessageAttachment(
        sessionId,
        messageId,
        attachmentId,
      ),
  });
}
